import {
  GET_WALK_ROUTE_REQUEST,
  GET_WALK_ROUTE_FAILURE,
  GET_WALK_ROUTE_SUCCESS,
  RESET_WALK_ROUTE_DATA,
} from './actionTypes';

const initialState = {
  walkRoute: { prospects: [] },
  loading: false,
  error: null,
};

const viewWalkRouteReducer = (state = initialState, {
  type, error, walkRoute,
}) => {
  switch (type) {
    case GET_WALK_ROUTE_REQUEST:
      return { ...state, loading: true };
    case GET_WALK_ROUTE_SUCCESS:
      return {
        ...state, loading: false, walkRoute,
      };
    case GET_WALK_ROUTE_FAILURE:
      return {
        ...state,
        loading: false,
        error,
      };

    case RESET_WALK_ROUTE_DATA:
      return initialState;

    default:
      return state;
  }
};

export default viewWalkRouteReducer;
